// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-button {
  height: 30px;
  width: 30px;
  --padding-start: 0;
  --padding-end: 0;
  flex-shrink: 0;
}
ion-header ion-button ion-icon {
  color: var(--ion-color-medium-shade);
}

h2 {
  font-size: 16px;
  line-height: 1.5;
  margin-block: 10px;
}

ion-content > * + * {
  margin-top: 20px;
}

ion-radio-group ion-radio {
  margin-inline-end: 10px;
}
ion-radio-group .position-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
ion-radio-group .position-img ion-icon {
  font-size: 40px;
}

:host ::ng-deep div.color-picker {
  margin-top: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: absolute !important;
  top: 100% !important;
  left: auto !important;
  right: 8px !important;
}
:host ::ng-deep div.color-picker .arrow.arrow-bottom {
  left: calc(100% - 20px) !important;
}

.picker-container {
  position: relative;
  display: flex;
  align-items: center;
}
.picker-container h2 {
  margin-right: auto;
}

input {
  cursor: pointer;
  height: 44px;
  width: 44px;
  border-radius: 10px;
  border: 2px solid var(--ion-color-primary);
  margin-right: 8px;
  color: transparent;
}

ion-content {
  --padding-start: calc(var(--ion-safe-area-left) + 16px);
  --padding-end: calc(var(--ion-safe-area-right) + 16px);
}

ion-item {
  --ion-safe-area-left: 0px;
  --ion-safe-area-right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/supervision-widget-settings/supervision-widget-settings.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAEQ;EACI,oCAAA;AAAZ;;AAKA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAMI;EACI,uBAAA;AAHR;AAMI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAMQ;EACI,eAAA;AAJZ;;AAYA;EACI,gBAAA;EACA,oCAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;AATJ;AAWI;EACI,kCAAA;AATR;;AAaA;EAEI,kBAAA;EACA,aAAA;EACA,mBAAA;AAXJ;AAaI;EACI,kBAAA;AAXR;;AAeA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,iBAAA;EACA,kBAAA;AAZJ;;AAgBA;EACI,uDAAA;EACA,sDAAA;AAbJ;;AAiBA;EACI,yBAAA;EACA,0BAAA;AAdJ","sourcesContent":["ion-header {\n    ion-button {\n        height: 30px;\n        width: 30px;\n        --padding-start: 0;\n        --padding-end: 0;\n        flex-shrink: 0;\n\n        ion-icon {\n            color: var(--ion-color-medium-shade);\n        }\n    }\n}\n\nh2 {\n    font-size: 16px;\n    line-height: 1.5;\n    margin-block: 10px;\n}\n\nion-content>*+* {\n    margin-top: 20px;\n}\n\nion-radio-group {\n    ion-radio {\n        margin-inline-end: 10px;\n    }\n\n    .position-img {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n        ion-icon {\n            font-size: 40px;\n        }\n    }\n}\n\n// The library positions the dialog with inline top/left from the page of the modal: anchor it to the color square instead,\n// right below it and aligned to its right edge, so it stays next to the square on every screen size.\n// Scoped to this component: without :host the rule would leak to the other color pickers (e.g. weekly planning, global.scss)\n:host ::ng-deep div.color-picker {\n    margin-top: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    position: absolute !important;\n    top: 100% !important;\n    left: auto !important;\n    right: 8px !important;\n\n    .arrow.arrow-bottom {\n        left: calc(100% - 20px) !important;\n    }\n}\n\n.picker-container {\n    // Anchor of the color picker dialog\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    h2 {\n        margin-right: auto;\n    }\n}\n\ninput {\n    cursor: pointer;\n    height: 44px;\n    width: 44px;\n    border-radius: 10px;\n    border: 2px solid var(--ion-color-primary);\n    margin-right: 8px;\n    color: transparent;\n}\n\n// Side padding clear of the notch in landscape; the bottom safe area is handled by the footer\nion-content {\n    --padding-start: calc(var(--ion-safe-area-left) + 16px);\n    --padding-end: calc(var(--ion-safe-area-right) + 16px);\n}\n\n// The items add the side safe area to their own padding: the content already has it\nion-item {\n    --ion-safe-area-left: 0px;\n    --ion-safe-area-right: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
